import IcLoader from '@/assets/svg/ic-loader.svg?inline'

export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IcLoader
  }
}